<template>
  <div class="table-wrapper">
    <div :class="['table-wrapper-inner', { 'hide-selection': !multiSelectMode}]">
      <el-row class="table-top-panel">
        <el-col  class="select">
          <template v-if="multiSelect">
            <template v-if="multiSelectMode">
              <el-checkbox v-model="checkAll" class="header_col_selection" :indeterminate="isIndeterminate" @change="handleSelectAll"></el-checkbox>
            </template>
          </template>
        </el-col>
        <el-col class="counter">
          該当件数：{{counter}}件
        </el-col>
        <el-col class="top-pagination other-command" v-if="tableData.length !== 0">
          <div class="block">
            <el-pagination
              small
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="selectPageSizes"
              :page-size="pageSize"
              layout="sizes, prev, pager, next, jumper"
              :total="tableData.length">
            </el-pagination>
          </div>
        </el-col>
        <el-col class="other-command" v-else>
          <slot name="other-command" />
        </el-col>
        <el-col v-if="csvExport" class="csv-export">
          <LinkTextFile
            ref="csvExport"
            type="primary"
            :disabled="tableData.length === 0"
            :fileName="csvFileName"
            :encoding="csvEncoding"
            contentType="text/csv"
            :fileData="json2csv(tableData)"
          >CSV出力</LinkTextFile>
        </el-col>
        <template v-if="multiSelect">
          <template v-if="!multiSelectMode">
            <el-col class="multi-select">
              <el-link type="primary"  @click="clickMultipleSelect">複数選択</el-link>
            </el-col>
          </template>
          <template v-else>
            <el-col class="cancel">
              <el-link type="primary"  @click="clickCancel">キャンセル</el-link>
              <el-link @click="clickMultipleDelete" class="el-icon-delete" :disabled="disabledMultipleDelete"></el-link>
            </el-col>
          </template>
        </template>
      </el-row>
      <el-table
        ref="table"
        :data="setTable"
        :highlight-current-row="true"
        :table-header-name="tableHeaderName"
        @header-click="clickHeader"
        @row-click="clickRow"
      >
        <el-table-column class-name="col-selection">
          <template slot-scope="scope" >
            <el-checkbox type="checkbox" v-model="scope.row.selected" :disabled="!selectable(scope.row)"></el-checkbox>
          </template>
        </el-table-column>
        <slot name="columns" />
      </el-table>
    </div>
    <transition>
      <div class="el-backtop" v-show="displayTopLink" @click="toTop()">
        <i class="el-icon-caret-top"></i>
      </div>
    </transition>
  </div>
</template>

<script>
import LinkTextFile from '@/components/atoms/LinkTextFile.vue'

export default {
  components: {
    LinkTextFile
  },
  props: {
    tableData: {
      type: Array,
      default: () => ([])
    },
    csvExport: {
      type: Boolean,
      default: false
    },
    csvFileName: {
      type: String,
      default: 'ダウンロード.csv'
    },
    csvEncoding: {
      type: String,
      default: 'UNICODE'
    },
    dataFormatter: {
      type: Function,
      default: row => row
    },
    multiSelect: {
      type: Boolean,
      default: true
    },
    defaultSort: Object,
    selectable: {
      type: Function,
      default: () => true
    },
    tableHeaderName: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      multiSelectMode: false,
      currentPage: 1,
      pageSize: 100,
      selectPageSizes: [50, 100, 200],
      sort: {
        key: '', // ソートキー
        class: '', // classキー
        isAsc: false // 昇順ならtrue,降順ならfalse
      },
      checkAll: false,
      isIndeterminate: false,
      displayTopLink: false,
      scroll: 0
    }
  },
  computed: {
    setTable () {
      var workTable = []
      if (this.tableData.length > 0) {
        var nextCnt = ((this.currentPage * this.pageSize) - 1 > (this.tableData.length - 1) ? (this.tableData.length - 1) : (this.currentPage * this.pageSize) - 1)
        for (var i = (this.currentPage - 1) * this.pageSize; i <= nextCnt; i += 1) {
          workTable.push(this.tableData[i])
        }
      }
      return workTable
    },
    counter: {
      get () {
        return this.tableData.length.toLocaleString()
      }
    },
    disabledMultipleDelete: {
      get () {
        // return this.$refs.table.selection.length === 0
        var data = this.tableData
        var result = data.filter(x => x.selected === true)
        if (this.multiSelectMode) {
          // ヘッダー選択状況取得
          this.getIsIndeterminate(result.length)
        }
        return result.length === 0
      }
    }
  },
  mounted () {
    const el = this.$el
    const tableHeader = el.querySelector('.el-table__header-wrapper')
    const tableTopPanel = el.querySelector('.table-top-panel')
    this.$nextTick(() => {
      const tableHeaderRect = tableHeader.getBoundingClientRect()
      const tableTopPanelRect = tableTopPanel.getBoundingClientRect()
      tableTopPanel.style.top = tableTopPanelRect.top + 'px'
      tableHeader.style.top = tableHeaderRect.top + 'px'
      const blankCol = tableHeader.querySelector('th.blank')
      if (blankCol) {
        el.style.setProperty('--table-width', '100%')
      }
    })
    window.addEventListener('scroll', this.scrollWindow)
  },
  methods: {
    getIsIndeterminate (selectedCount) {
      if (selectedCount === 0) {
        this.isIndeterminate = false
      } else {
        var selectableRecordCount = 0
        for (var i = 0; i <= this.tableData.length - 1; i += 1) {
          if (this.selectable(this.tableData[i])) {
            selectableRecordCount += 1
          }
        }
        this.checkAll = selectedCount === selectableRecordCount
        this.isIndeterminate = selectedCount > 0 && selectedCount < selectableRecordCount
      }
    },
    handleSelectAll (val) {
      for (var i = 0; i <= this.tableData.length - 1; i += 1) {
        if (this.selectable(this.tableData[i])) {
          this.tableData[i].selected = val
        } else {
          this.tableData[i].selected = false
        }
      }
      this.isIndeterminate = false
    },
    json2csv (table) {
      var recordheader = ''
      var recorddata = ''
      if (table.length > 0) {
        recordheader = this.tableHeaderName
        // recordheader = Object.keys(table[0])
        recorddata = table.map(row => this.csvRowFormat(this.dataFormatter(row))).join('\r\n') + '\r\n'
        recorddata = recordheader + '\r\n' + recorddata
      }
      return recorddata
    },
    csvRowFormat (row) {
      const result = Object.keys(row).map(key => this.csvCellFormat(row[key])).join(',')
      return result
    },
    csvCellFormat (cell) {
      var cvCell = (cell + '').trimEnd()
      cvCell = cvCell.replace('"', '""')
      const re = /[,"\r\n]/
      if (re.test(cvCell)) {
        cvCell = '"' + cvCell + '"'
      }
      return cvCell
    },
    clickMultipleSelect () {
      this.multiSelectMode = true
    },
    clickCancel () {
      this.multiSelectMode = false
    },
    clickMultipleDelete () {
      // this.$emit('multiple-delete', this.$refs.table.selection)
      var data = this.tableData
      var result = data.filter(x => x.selected === true)
      this.$emit('multiple-delete', result)
    },
    clickRow (row, column, event) {
      // this.$emit('row-click', row, column, event)
      if (column.className !== 'col-selection') {
        this.$emit('row-click', row, this.tableData)
      }
    },
    clickHeader (column, event) {
      // this.tableData = this.sortBy(column.property, this.tableData)
      this.tableData = this.sortBy(column, this.tableData)
      this.toTop()
      this.currentPage = 1
    },
    handleSizeChange (val) {
      this.toTop()
      this.pageSize = val
      this.currentPage = 1
    },
    handleCurrentChange (val) {
      this.toTop()
      this.currentPage = val
    },
    toTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    scrollWindow () {
      const top = 200
      this.scroll = window.scrollY
      if (top <= this.scroll) {
        this.displayTopLink = true
      } else {
        this.displayTopLink = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  --table-width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  ::v-deep.table-wrapper-inner {
    width: 100%;
    &.hide-selection {
      .el-table {
        .col-selection {
          visibility: hidden;
        }
      }
    }
    .table-top-panel {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      background-color: var(--background-color);
      position: sticky;
      z-index: 300;
      .el-col {
        width: auto;
        margin-left: 1em;
        height: 2em;
        display: flex;
        justify-content: center;
        align-items: center;
        &.multi-select {
          width: 8em;
          padding-right: 4em;
        }
        &.cancel {
          flex-grow: 0;
          width: 8em;
        }
        .el-icon-delete {
          margin-left: 1em;
          &::before {
            font-size: 1.5em;
          }
        }
      }
      .counter {
        color: blue;
      }
      .counter,
      .csv-export,
      .multi-select,
      .cancel {
        flex-grow: 0;
      }
      .select {
        width: 1em;
      }
      .other-command {
        flex-grow: 2;
      }
      .el-input--mini {
        width: 120px;
      }
    }
    .el-table {
      width: auto !important;
      background-color: var(--background-color);
      &:before {
        background-color: transparent;
      }
      col {
        width: auto !important;
      }
      .col-blank {
        visibility: hidden;
      }
      .el-table__header-wrapper {
        position: sticky;
        z-index: 200;
        display: inline-block;
        .el-table__empty-block {
          width: 100% !important;
        }
      }
      .el-table__body-wrapper {
        .el-table__empty-block {
          width: 100% !important;
        }
      }
      table {
        width: var(--table-width) !important;
      }
      tbody {
        color: black;
      }
      th,
      td {
        background-color: var(--background-color);
        // border: 1px solid brown;
      }
      &.el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: #F5F7FA
      }
      .col-selection {
        width: 2.6em;
        .el-checkbox {
          &.is-disabled {
            visibility: hidden;
          }
          .el-checkbox__input {
            .el-checkbox__inner {
              width: 1.1em;
              height: 1.1em;
              border-radius: 25%;
              border-width: 0.1em;
              border-color: var(--primary-color);
              &:after {
                border-width: 0.1em;
                height: 0.45em;
                width: 0.2em;
                top: 0.1em;
                left: 0.25em;
              }
            }
            &.is-checked,
            &.is-indeterminate {
              .el-checkbox__inner {
                background-color: var(--primary-color);
              }
            }
            &.is-indeterminate {
              .el-checkbox__inner:before {
                height: 0.2em;
                top: 0.3em;
              }
            }
          }
        }
      }
    }
    .header_col_selection {
      top: 39px;
      left: -3px;
      z-index: 999;
      width: 2.6em;
      &.is-disabled {
        visibility: hidden;
      }
      .el-checkbox__input {
        .el-checkbox__inner {
          width: 1.1em;
          height: 1.1em;
          border-radius: 25%;
          border-width: 0.1em;
          border-color: var(--primary-color);
          &:after {
            border-width: 0.1em;
            height: 0.45em;
            width: 0.2em;
            top: 0.1em;
            left: 0.25em;
          }
        }
        &.is-checked,
        &.is-indeterminate {
          .el-checkbox__inner {
            background-color: var(--primary-color);
          }
        }
        &.is-indeterminate {
          .el-checkbox__inner:before {
            height: 0.2em;
            top: 0.3em;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-input--mini .el-input__inner {
  height: 25px !important;
}
.el-pagination.is-background {
  .el-pager {
    li:not(.disabled).active {
      background-color: var(--primary-color) !important;
    }
    li:not(.disabled):hover {
      color: var(--primary-color) !important;
    }
  }
}
.el-backtop {
  right: 120px;
  bottom: 100px;

  .el-icon-caret-top {
    color: var(--primary-color) !important;
  }

  transition: all 0.6s;
  &.v-enter,
  &.v-leave-to {
    opacity: 0;
    bottom: 10px;
  }
}
</style>
